import { jsxs, jsx } from 'react/jsx-runtime';
import { isPresetGradientColor } from '@flex-design-system/fx-colors';
import { forwardRef } from 'react';
import { getColor } from '../utils/color.mjs';
import useId from './hooks/useId.mjs';
import { getID, FlexLinearGradient } from './shared/FlexLinearGradient.mjs';

const RobotIcon = forwardRef(
  ({
    color: rawColor = "currentColor",
    size: sizeFromProps,
    type = "default",
    style,
    ...props
  }, forwardedRef) => {
    const { id } = useId();
    const isGradient = isPresetGradientColor(rawColor);
    const color = isGradient ? `url(#${getID(rawColor, id)})` : getColor(rawColor);
    const size = sizeFromProps ?? 24;
    if (type === "fill") {
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: size,
          height: size,
          fill: "none",
          viewBox: "0 0 24 24",
          ...props,
          ref: forwardedRef,
          style: sizeFromProps !== void 0 ? { width: size, height: size, flexShrink: 0, ...style } : { flexShrink: 0, ...style },
          children: [
            isGradient && /* @__PURE__ */ jsx(FlexLinearGradient, { id }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M9 6.5a3 3 0 1 1 6 0v.118h1c1.602 0 2.9 1.306 2.9 2.918v8.047A2.909 2.909 0 0 1 16 20.5H8a2.909 2.909 0 0 1-2.9-2.917V9.536A2.909 2.909 0 0 1 8 6.618h1V6.5Zm6 9.876v-1.81H9v1.81h6Zm-4-4.326c0 .556-.448 1.006-1 1.006s-1-.45-1-1.006c0-.555.448-1.006 1-1.006s1 .45 1 1.006Zm3 1.006c.552 0 1-.45 1-1.006 0-.555-.448-1.006-1-1.006s-1 .45-1 1.006.448 1.006 1 1.006Z",
                fillRule: "evenodd",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M2 14.666c0 .5.403.905.9.905s.9-.405.9-.905v-2.213c0-.5-.403-.906-.9-.906s-.9.406-.9.906v2.213ZM21.1 11.547c.497 0 .9.406.9.906v2.213c0 .5-.403.905-.9.905a.903.903 0 0 1-.9-.905v-2.213c0-.5.403-.906.9-.906Z"
              }
            )
          ]
        }
      );
    }
    if (type === "default") {
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: size,
          height: size,
          fill: "none",
          viewBox: "0 0 24 24",
          ...props,
          ref: forwardedRef,
          style: sizeFromProps !== void 0 ? { width: size, height: size, flexShrink: 0, ...style } : { flexShrink: 0, ...style },
          children: [
            isGradient && /* @__PURE__ */ jsx(FlexLinearGradient, { id }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M12 3a3.176 3.176 0 0 0-3.176 3.176v.126h-1.06a3.08 3.08 0 0 0-3.07 3.089v8.52A3.08 3.08 0 0 0 7.764 21h8.471a3.08 3.08 0 0 0 3.07-3.089v-8.52a3.08 3.08 0 0 0-3.07-3.09h-1.058v-.125A3.177 3.177 0 0 0 12 3ZM6.6 9.39c0-.647.521-1.171 1.165-1.171h8.47c.643 0 1.165.524 1.165 1.172v8.52c0 .647-.521 1.172-1.165 1.172h-8.47A1.168 1.168 0 0 1 6.6 17.91v-8.52Zm2.224 5.326h6.353v1.917H8.824v-1.917Zm1.058-1.598c.585 0 1.06-.476 1.06-1.065 0-.588-.475-1.065-1.06-1.065-.584 0-1.058.477-1.058 1.065 0 .589.474 1.065 1.058 1.065Zm5.295-1.065c0 .589-.475 1.065-1.06 1.065a1.062 1.062 0 0 1-1.058-1.065c0-.588.474-1.065 1.059-1.065.584 0 1.059.477 1.059 1.065ZM2.365 15.781a.956.956 0 0 1-.953-.959V12.48c0-.53.426-.958.953-.958.526 0 .953.429.953.958v2.343c0 .53-.427.959-.953.959Zm19.27-4.26c.527 0 .953.429.953.958v2.344c0 .529-.426.958-.953.958a.956.956 0 0 1-.953-.959V12.48c0-.53.427-.958.953-.958Z",
                fillRule: "evenodd",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
    console.error(
      `RobotIcon doesn't support the combination of ${size} and ${type}`
    );
    return null;
  }
);

export { RobotIcon };
//# sourceMappingURL=RobotIcon.mjs.map
